/*
 * Use fetch() instead of axios() for media download
 * Reason: https://github.com/eligrey/FileSaver.js/issues/483
 *
 * Tl;dr - you need to set both cors mode and disable cache for downloads to work reliably
 *
 * Set cors mode to ensure headers are checked properly, otherwise accessing blob()
 * on the result will fail. When images are downloaded to show in the UI they will have
 * Sec-Fetch-Mode: no-cors by default. So if the cached version is downloaded, calling
 * blob() will fail.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Request/mode
 * https://developer.mozilla.org/en-US/docs/Web/API/Request/cache
 */
export const s3MediaRequest = async (input: RequestInfo | URL) => {
  const result = await fetch(input, {
    mode: 'cors',
    cache: 'no-cache',
  });
  return result.blob();
};
